import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Pagination,
} from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DashboardCard from "./DashboardCard";
import { useNavigate } from "react-router-dom";

const ITEMS_PER_PAGE = 5;

const ViolationSummary = ({ violations }) => {
  const navigate = useNavigate();
  const resolved = violations.filter((v) => v.status === "resolved").length;
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setPage(1);
  };

  const paginatedViolations = violations.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  return (
    <>
      <DashboardCard title="Violation Summary">
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography>Total Violations:</Typography>
            <Typography variant="h4" color="error">
              {violations.length}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>Resolved:</Typography>
            <Typography variant="h4" color="success">
              {resolved}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 1 }}>
          {violations.slice(0, 2).map((violation) => (
            <Grid item xs={12} md={6} key={violation.id}>
              <Paper
                sx={{
                  p: 2,
                  backgroundColor: "#f9f9f9",
                  borderRadius: "10px",
                  boxShadow: 1,
                }}
              >
                <Typography>
                  <strong>ID:</strong> {violation.id}
                </Typography>
                <Typography>
                  <strong>Type:</strong> {violation.type || "N/A"}
                </Typography>
                <Typography>
                  <strong>Status:</strong> {violation.status}
                </Typography>
                <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => navigate(`/home/memberspage/violation/${violation.id}`)}
                  >
                    View Details
                  </Button>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {violations.length > 2 && (
          <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AssignmentTurnedInIcon />}
              onClick={handleOpen}
            >
              View All Violations
            </Button>
          </Box>
        )}
      </DashboardCard>

      {/* Modal for all violations */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>All Violations</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {paginatedViolations.map((violation) => (
              <Grid item xs={12} key={violation.id}>
                <Paper
                  sx={{
                    p: 2,
                    backgroundColor: "#f9f9f9",
                    borderRadius: "10px",
                    boxShadow: 1,
                  }}
                >
                  <Typography>
                    <strong>ID:</strong> {violation.id}
                  </Typography>
                  <Typography>
                    <strong>Type:</strong> {violation.type || "N/A"}
                  </Typography>
                  <Typography>
                    <strong>Status:</strong> {violation.status}
                  </Typography>
                  <Typography>
                    <strong>Description:</strong>{" "}
                    {violation.description || "No description"}
                  </Typography>
                  <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
                  <Button
  variant="outlined"
  size="small"
  onClick={() => navigate(`/home/memberspage/violation/${violation.id}`)}


>
  View Details
</Button>


                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: "center", flexDirection: "column", gap: 1 }}
        >
          <Pagination
            count={Math.ceil(violations.length / ITEMS_PER_PAGE)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViolationSummary;
